import { getAuthMeta } from './auth'
import { retainedQuery } from './session'
import { kitBindContext } from './kitBindContext'
import { draftKey, getDraftStorage, removeDraft } from './surveyWorkflow'

export function clearRevokedRegistration (checkId, envKey) {
  const auth = getAuthMeta()
  const environment = envKey || auth.envKey || ''
  removeDraft(getDraftStorage(), draftKey(auth, environment, checkId))
  kitBindContext({ pid: checkId, envKey: environment, state: '' }, checkId)
}

export function revokedHomeQuery () {
  // 空值显式覆盖URL search中遗留的pid，防止首页再次打开已撤销检测。
  return retainedQuery({ pid: '', code: '', checkId: '', patientId: '', serialNum: '', state: '', section: '', mode: '', returnTo: '', newTest: '' })
}



// WEBPACK FOOTER //
// ./src/utils/registrationRevoke.js